import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AppHeader } from './components/AppHeader'
import { LoadingState } from './components/LoadingState'
import { NotFoundPage } from './pages/NotFoundPage'
import { TRAFFIC_TAB_ENABLED } from './config/features'

const PortfolioPage = lazy(async () => ({ default: (await import('./pages/PortfolioPage')).PortfolioPage }))
const StationPage = lazy(async () => ({ default: (await import('./pages/StationPage')).StationPage }))

const RecordsPage = lazy(async () => ({ default: (await import('./pages/RecordsPage')).RecordsPage }))

const AxleLoadPage = lazy(async () => ({ default: (await import('./pages/AxleLoadPage')).AxleLoadPage }))

const DownloadsPage = lazy(async () => ({ default: (await import('./pages/DownloadsPage')).DownloadsPage }))
const LivestreamsPage = lazy(async () => ({ default: (await import('./pages/LivestreamsPage')).LivestreamsPage }))
const TrafficPage = lazy(async () => ({ default: (await import('./pages/TrafficPage')).TrafficPage }))

export function App() {
  if (import.meta.env.VITE_OPERATIONS_PAUSED === 'true') {
    return (
      <div className="app-shell">
        <main id="main-content" className="page-shell">
          <section className="empty-state">
            <h1>Dashboard paused</h1>
            <span>Live updates and uploads are temporarily paused by the administrator.</span>
            <span>Existing records are saved.</span>
          </section>
        </main>
      </div>
    )
  }
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <AppHeader />
      <Suspense fallback={<main id="main-content" className="page-shell"><LoadingState label="Loading interface" /></main>}>
        <Routes>
          <Route path="/" element={<PortfolioPage />} />
          <Route path="/stations/:stationId" element={<StationPage />} />
          <Route path="/axle-load" element={<AxleLoadPage />} />
          <Route path="/downloads" element={<DownloadsPage />} />
          <Route path="/records" element={<RecordsPage />} />
          <Route path="/livestreams" element={<LivestreamsPage />} />
          <Route path="/traffic" element={TRAFFIC_TAB_ENABLED ? <TrafficPage /> : <Navigate to="/" replace />} />
          <Route path="/network" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </div>
  )
}
